import { WellframeApi } from 'store/api';
import { CareProgramAPIResponse, CareProgramRequestStatus } from 'features/resources/types';

export interface RequestCareProgramRequest {
  memberUuid: string;
  programId: number;
}

export interface CareProgramSubscription {
  id: number;
  program_user_id: number;
  care_program_id: number;
  start_date: string;
  end_date: string | null;
  starter_id: number | null;
  ender_name: string | null;
  ender_id: number | null;
  starter_type: string | null;
  offset: number;
  ender_type: string | null;
  program_end_reason_id: number | null;
  end_reason_free_text: string | null;
  is_ended: boolean;
}

export interface RequestCareProgramResponse {
  id: string;
  care_program_id: number;
  requested_by_id: number;
  requested_on: string;
  status: CareProgramRequestStatus;
  approved_by_id: number | null;
  approved_on: string | null;
  declined_by_id: number | null;
  declined_reason: string | null;
  declined_on: string | null;
  care_program: CareProgramAPIResponse | null;
  member_notified_at: string | null;
  care_program_subscription: CareProgramSubscription | null;
}

export interface GetCareProgramRequestsRequest {
  memberUuid: string;
}

export interface UpdateCareProgramRequestRequest {
  memberUuid: string;
  id: string;
  memberNotifiedAt: string;
}

export const careProgramRequestService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    getCareProgramRequests: builder.query<
      RequestCareProgramResponse[],
      GetCareProgramRequestsRequest
    >({
      query: ({ memberUuid }) => `/mobileapi/v2/members/${memberUuid}/care-program-requests`,
    }),
    requestCareProgram: builder.mutation<RequestCareProgramResponse, RequestCareProgramRequest>({
      query: ({ memberUuid, programId }) => ({
        url: `/mobileapi/v1/members/${memberUuid}/care-program-requests`,
        method: 'POST',
        body: { care_program_id: programId.toString() },
      }),
    }),
    updateCareProgramRequest: builder.mutation<
      RequestCareProgramResponse,
      UpdateCareProgramRequestRequest
    >({
      query: ({ memberUuid, id, memberNotifiedAt }) => ({
        url: `/mobileapi/v1/members/${memberUuid}/care-program-requests/${id}`,
        method: 'PATCH',
        body: { member_notified_at: memberNotifiedAt },
      }),
    }),
  }),
});

export const {
  useGetCareProgramRequestsQuery,
  useRequestCareProgramMutation,
  useUpdateCareProgramRequestMutation,
} = careProgramRequestService;
